import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { purple } from "@material-ui/core/colors";
import React from "react";

const PolicyModal = ({ open, set }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        set(false);
      }}
    >
      <Grid item xs={12} container>
        <DialogTitle id="alert-dialog-title" style={{ color: purple[400] }}>
          Política de privacidad
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography
              variant="body2"
              gutterBottom
              style={{ paddingBottom: 8, textAlign: "justify" }}
            >
              De conformidad con la normativa vigente y aplicable en protección
              de datos de carácter personal, le informamos que sus datos serán
              incorporados al sistema de tratamiento titularidad de OSATU S COOP
              con CIF F48113161 y domicilio social sito en EDIFICIO
              ZEARREKOBUELTA SUBIDA DE AREITIO 5 - 48260 ERMUA (BIZKAIA), y que
              a continuación se relacionan sus respectivas finalidades, plazos
              de conservación y bases legitimadoras. Para aquellos tratamientos
              que lo requieran, se informa también de la posible elaboración de
              perfiles y decisiones automatizadas, así como las posibles
              cesiones y las transferencias internacionales que OSATU S COOP
              tiene previsto realizar:
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Captación, registro y tratamiento de datos de los
              participantes para la gestión de las formaciones y/o cursos,
              expediente académico, calificaciones e instancias.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Plazo de conservación: durante el plazo estrictamente necesario
              para cumplir con la finalidad anteriormente mencionada.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Base legítima: El consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18, textAlign: "justify" }}
            >
              - Cesiones: sus datos serán comunicados en caso de ser necesario a
              entidades formadoras colaboradoras con la finalidad de cumplir con
              la inscripción e impartición de las formaciones, así como la
              expedición de títulos. Además, se informa que la base legitimadora
              de la cesión es la ejecución del contrato.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Gestión y tramitación de las obligaciones y deberes
              que se deriven del cumplimiento de la normativa a la cual está
              sujeta la entidad
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Plazo de conservación: conservación de las copias de los
              documentos hasta que prescriban las acciones para reclamarle una
              posible responsabilidad.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Base legítima: El cumplimiento de una ley.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18, textAlign: "justify" }}
            >
              - Cesiones: sus datos serán comunicados en caso de ser necesario a
              Organismos y/o administración pública con competencia en la
              materia con la finalidad de cumplir con las obligaciones
              establecidas en la normativa aplicable. Además, se informa que la
              base legitimadora de la cesión es el cumplimiento de una ley.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Finalidad: Gestión administrativa, facturación, contabilidad y
              obligaciones legales.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Plazo de conservación: 5 años en cumplimiento de la ley
              tributaria y 10 años ladocumentación fiscal en cumplimiento de la
              L.O. 7/2012.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Base legítima: El cumplimiento de una ley.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Cesiones: sus datos serán comunicados en caso de ser necesario a
              Agencia Tributaria,
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginBottom: 12, textAlign: "justify" }}
            >
              Bancos, Cajas y Organismos y/o administración pública con
              competencia en la materia con la finalidad de cumplir con las
              obligaciones tributarias y fiscales establecidas en la normativa
              aplicable. Además, se informa que la base legitimadora de la
              cesión es el cumplimiento de una ley.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Captación, registro y tratamiento de imágenes de las
              imágenes captadas mediante fotografías y/o videos realizados por
              la entidad, con la finalidad de potenciar la imagen corporativa
              y/o promocionar las actividades de la entidad y publicarlas en la
              página web y/o redes sociales de la entidad
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Plazo de conservación: mientras se mantenga el consentimiento
              prestado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18, textAlign: "justify" }}
            >
              - Base legítima: El consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Captación, registro y tratamiento de imágenes de las
              imágenes captadas mediante fotografías y/o videos realizados por
              la entidad, con la finalidad de potenciar la imagen corporativa
              y/o promocionar las actividades de la entidad y publicarlas en la
              página web y/o redes sociales de la entidad colaboradora.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Plazo de conservación: mientras se mantenga el consentimiento
              prestado.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Base legítima: El consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18, textAlign: "justify" }}
            >
              - Cesiones: sus datos serán comunicados en caso de ser necesario a
              empresas colaboradoras del sector con la finalidad de publicarlas
              en la página web y/o redes sociales de sus entidades como ventaja
              por ser clientes, asociados y/o participantes de OSATU S COOP.
              Además, se informa que la base legitimadora de la cesión es el
              consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginBottom: 12, textAlign: "justify" }}
            >
              Igualmente y de acuerdo con lo que establece la Ley 1/1982, de 5
              de mayo, sobre el derecho al honor, a la intimidad personal y
              familiar y a la propia imagen, solicitamos su consentimiento para
              utilizar las imágenes captadas mediante fotografías y/o videos
              realizados por nuestra entidad, con la finalidad anteriormente
              mencionada.
            </Typography>
            <Typography variant="body2"> </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Captación, registro y tratamiento de datos con
              finalidades de publicidad y prospección comercial
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Plazo de conservación: mientras se mantenga el consentimiento
              prestado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18 }}
            >
              - Base legítima: El consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12, textAlign: "justify" }}
            >
              - Finalidad: Captación, registro y tratamiento de datos con
              finalidades de publicidad y prospección comercial con cesión a
              empresas colaboradoras del sector.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Plazo de conservación: mientras se mantenga el consentimiento
              prestado.
            </Typography>
            <Typography
              variant="body2"
              style={{ marginLeft: 32, marginBottom: 12 }}
            >
              - Base legítima: El consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginLeft: 32, marginBottom: 18, textAlign: "justify" }}
            >
              - Cesiones: sus datos serán comunicados en caso de ser necesario a
              empresas colaboradoras del sector con la finalidad de realizar
              publicidad, promociones de servicios y prospección comercial como
              ventaja por ser clientes, asociados y/o participantes de OSATU S
              COOP. Además, se informa que la base legitimadora de la cesión es
              el consentimiento del interesado.
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginBottom: 18, textAlign: "justify" }}
            >
              Asimismo, y de acuerdo con lo establecido en la Ley 34/2002, de 11
              de julio, de Servicios de la Sociedad de la Información y de
              Comercio Electrónico, en su artículo 21, solicitamos su
              consentimiento explícito para enviarle publicidad que consideremos
              puedan ser de su interés, por correo electrónico o por cualquier
              otro medio de comunicación electrónica equivalente que usted ha
              proporcionado en la toma de datos:
            </Typography>
            <Typography
              variant="body2"
              gutterBottom
              style={{ marginBottom: 18, textAlign: "justify" }}
            >
              De acuerdo con los derechos que le confiere la normativa vigente y
              aplicable en protección de datos podrá ejercer los derechos de
              acceso, rectificación, limitación de tratamiento, supresión
              (“derecho al olvido”), portabilidad y oposición al tratamiento de
              sus datos de carácter personal así como la revocación del
              consentimiento prestado para el tratamiento de los mismos,
              dirigiendo su petición a la dirección postal indicada más arriba o
              al correo electrónico info@bexencardio.com. Podrá dirigirse a la
              Autoridad de Control competente para presentar la reclamación que
              considere oportuna.
            </Typography>
          </DialogContentText>
        </DialogContent>
      </Grid>
    </Dialog>
  );
};

export default PolicyModal;
